"use strict";
/*
 * Created on 6. 3. 2020
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var PromotionSplitOptionEnum_1 = require("../../promotion/model/PromotionSplitOptionEnum");
/**
 * Representation of one day forecast of single window item. The item may belong to promotion as well as to simulation.
 * Particular instances represents aggregation of forecast amounts for all sites related to particular window item.
 * To support week aggregations the class also contains name of week the amount belongs to.
 *
 * @author Stepan Mik
 */


var WindowItemForecast =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowItemForecast, _DomainObject_1$Domai);

  function WindowItemForecast(id, windowItemId, windowId, //to allow block deletion
  productId, //to support promotion overlap handling (if necessary)?
  date, amount, calendarWeek, promoWeek, splitOption) {
    var _this;

    _classCallCheck(this, WindowItemForecast);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowItemForecast).call(this));
    _this.id = id;
    _this.windowItemId = windowItemId;
    _this.windowId = windowId;
    _this.productId = productId;
    _this.date = date;
    _this.amount = amount;
    _this.calendarWeek = calendarWeek;
    _this.promoWeek = promoWeek;
    _this.splitOption = splitOption;
    return _this;
  }

  _createClass(WindowItemForecast, null, [{
    key: "fromMat",
    value: function fromMat(mat) {
      return new WindowItemForecast(mat.id, mat.windowItemId, mat.windowId, mat.productId, mat.date, mat.amount, mat.calendarWeek, mat.promoWeek, mat.splitOption);
    }
  }]);

  return WindowItemForecast;
}(DomainObject_1.DomainObject);

exports.WindowItemForecast = WindowItemForecast;

WindowItemForecast.schema = function () {
  var bld = new StructPropBuilder_1.StructPropBuilder(WindowItemForecast.name);
  return {
    id: bld.id('id'),
    windowItemId: bld.id('windowItemId'),
    windowId: bld.id('windowId'),
    productId: bld.id('productId'),
    date: bld.date('date'),
    amount: bld.bigNum('amount'),
    calendarWeek: bld.str('calendarWeek'),
    promoWeek: bld.str('promoWeek'),
    splitOption: bld.senum('splitOption', PromotionSplitOptionEnum_1.PromotionSplitOptionsEnum, CodebookLookupSequence_1.CodebookLookupSequence.PromotionSplitOptions)
  };
}();